<script setup lang="ts">
import type { InputHTMLAttributes } from 'vue'

defineProps<{
  class?: InputHTMLAttributes['class']
}>()

const model = defineModel<string>()
</script>

<template>
  <input
    v-model="model"
    :class="
      cn([
        'border border-grey focus:border-primary outline-none rounded-xl bg-white/50 px-3 py-2 transition group-has-[input]/input-icon:flex-1 group-has-[input]/input-icon:rounded-l-none group-focus-within/input-icon:border-primary',
        $props.class,
      ])
    "
  />
</template>

<style lang="postcss" scoped>
input::file-selector-button {
  @apply rounded-full font-kyiv font-medium inline-flex items-center transition-colors duration-150 justify-center disabled:opacity-50 whitespace-nowrap bg-secondary hover:bg-secondary-dark text-white border-0 px-4 py-2 gap-2 rounded-r-none -my-4 -ml-3 mr-4 cursor-pointer;
}

input[type='file'] {
  @apply cursor-pointer rounded-l-full rounded-r-full;
}
</style>
